import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import AuditDashboard from '../components/organisms/AuditDashboard';
import Button from '../components/atoms/Button';
import ResponsiveContainer from '../components/molecules/ResponsiveContainer';

const AuditDashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  
  // Check if user is admin (richierodney434@gmail.com)
  const isAdmin = user?.email === 'richierodney434@gmail.com';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                icon={ArrowLeft}
                onClick={() => navigate('/dashboard')}
                className="text-gray-600 hover:text-gray-900"
              >
                Back to Dashboard
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <ResponsiveContainer maxWidth="full" padding="none">
            <AuditDashboard />
          </ResponsiveContainer>
        </motion.div>
      </div>
    </div>
  );
};

export default AuditDashboardPage;